import { DocumentBody } from "@/features/service-information/DocumentBody";
import document from "./scope-document.json";

export function LicenseScopeDocument() {
  return <article className="text-sm leading-7"><DocumentBody blocks={[{ ...document.blocks[0], runs: [{ text: document.title, bold: true }] }, ...document.blocks.slice(1)]} /></article>;
}
